<template>
  <div>
    <h2 class="mb-6 text-uppercase text-center">
      Single User
    </h2>
    <h4 class="mb-2">
      12 Document Credits | 5GB storage limit
    </h4>
    <ul class="mb-6">
      <li>Automated Document and Asset Registers</li>
      <li>Unlimited registry entries</li>
      <li>
        Self-generate unlimited digital smart contracts (subject to credit
        system)
      </li>
      <li>Upload any document for e-signature</li>
      <li>Collaborate with counterparties</li>
      <li>Request legal expert reviews</li>
      <li>Estate documents package</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'SingleUserPlanDescription'
}
</script>
<style lang="sss" scoped></style>
